<template>
  <div class="base-shot-list">
    <loading v-if="loading"></loading>
    <div v-else>
      <!-- <van-search shape="round" :left-icon="require('../../assets/iconImage/ic_20_search@2x.png')" placeholder="搜索最佳拍摄点" @click="toSearchPage" /> -->
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了..." @load="onLoad">
        <div class="best_container">
          <div class="best_item" v-for="(item,index) in listData" :key="index" @click="bestItem(item)">
            <div class="item_left" :style="{width:'75px'}">
              <van-image radius="3px" :width="75" :height="100" :src="item.imageUrl" />
            </div>
            <div class="item_right">
              <div class="title">{{item.title}}</div>
              <div class="distance">
                <span class="distance" v-if="isShowDistance">距你{{distance(item.latitude,item.longitude)}}</span>
                <!-- <span class="location">{{item.address}}</span> -->
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>
<script>
import Loading from '@/components/loading';
import { getDistance } from '../../common/common';
export default {
  data() {
    return {
      locationIcon: require('../../assets/iconImage/ic_20_location@2x.png'),
      listData: [],
      loading: false,
      finished: false,
      p: 1,
      pn: '10',
      latitude: '',
      longitude: '',
      isShowDistance:false,
    };
  },
  components: {
    Loading
  },
  mounted() {
    window.document.title = '最佳拍摄点';
    this.isShowDistance = Boolean(sessionStorage.getItem('isShowDistance'));
    this.getShootList();
  },
  methods: {
    onLoad() {
      // 异步更新数据
      this.p = this.p + 1;
      this.getShootList();
    },

    /**
    * 点击 跳转搜索页
    */
    toSearchPage() {
      this.$router.push({
        path: '/bigSearch',
      });
    },

    /**
     * 去拍摄点详情
     */
    bestItem(item) {
      console.log(item.filmId, 'itemitemitemitme');
      this.$router.push({
        name: "bestShotDetail",
        query: {
          id: item.filmId,
          lat: this.$route.query.lat,
          lng: this.$route.query.lng,
        },
      });

    },

    /**
     * 计算距离你多少距离
     * @params lat lng 景区 景点 经纬度
     */
    distance(lat, lng) {
      if (this.$route.query.lat && this.$route.query.lng) {
        let obj = getDistance(lat, lng, this.$route.query.lat, this.$route.query.lng);
        return obj.distance.toFixed(1) + (obj.type == 'km' ? '公里' : '米');
      } else {
        // return { distance: '', text: '' };
        return '0米';
      }
    },
    //获取拍摄位列表
    getShootList() {
      this.loading = true;
      this.$request.get(
        `/appserver/v1/scenic/bestFilm?scenicId=${this.$route.query.id}&pageIndex=${this.p}&pageSize=${this.pn}`,
        {
          headers: {
            latitude: this.latitude, //纬度
            longitude: this.longitude, //经度
          },
        }
      ).then((data) => {
        let resData = data.data.data;
        // 列表数据获取
        if (resData) {
          let list = this.listData;
          this.listData = list.concat(resData);
        }
        // 数据为空
        if (this.pageIndex == 1 && (!resData || resData.length == 0)) {
          console.log('数据为空');
          this.loading = false;
          this.finished = true;
        }
        // 数据已加载完毕
        if ((resData.length == 0 && this.listData.length > 0) || resData.length < 10) {
          console.log('数据已加载完毕');
          this.finished = true;
        }
        this.loading = false;
        this.isLoading = false;
        this.finished = true;

        this.loading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.base-shot-list {
  .title {
    /deep/ .van-nav-bar .van-icon {
      color: #4a4a4a;
      font-size: 22px;
      font-weight: 600;
    }
    /deep/ .van-nav-bar__title {
      color: #4a4a4a;
      font-size: 16px;
      font-weight: 600;
    }
    /deep/ [class*="van-hairline"]::after {
      border: 0px;
    }
  }
  .best_container {
    padding: 20px;
    .best_item {
      display: flex;
      margin-bottom: 25px;
      .item_right {
        margin-left: 18px;
        .title {
          font-size: 16px;
          color: #262626;
          font-weight: 700;
          margin-bottom: 8px;
        }
        .item_title {
          margin-bottom: 4px;
        }
        .distance {
          font-size: 12px;
          color: #787878;
          // letter-spacing: 0.5px;
          // display: flex;
          // align-items: center;
          .location {
            margin-left: 4px;
          }
        }
        .label_box {
          display: flex;
          margin-bottom: 6px;
          .label {
            padding: 2px 5px;
            background: rgba(97, 69, 247, 0.15);
            border-radius: 2px;
            color: #6145f7;
            margin-right: 4px;
          }
        }
      }
    }
  }
  .list {
    padding: 6px 20px;
    .list-item {
      position: relative;
      /deep/ .van-image__img {
        border-radius: 2px;
      }
      .bg-show {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 189px;
        z-index: 200;
        background: rgba(0, 0, 0, 0.04);
        border-radius: 2px;
      }
      .distance {
        position: absolute;
        top: 0;
        left: 0;
        padding: 7px 10px;
        background: rgba(0, 0, 0, 0.04);
        border-radius: 2px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFangSC;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
      }
      & > h5 {
        font-size: 15px;
        font-family: PingFangTC-Medium, PingFangTC;
        font-weight: 600;
        color: rgba(85, 89, 89, 1);
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        margin-top: 15px;
      }
      .describe {
        width: 100%;
        margin-top: 8px;
        margin-bottom: 22px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        p {
          width: 90%;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFangSC;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
          margin: 0px;
          margin-left: 6px;
        }
      }
    }
  }
}
</style>
